import { Account, ConnectWalletButton } from '@/components/molecules'
import { Box } from '@chakra-ui/react'
import { useAccount } from 'wagmi'

export const ConnectWallet = ({ symbols, size, ...props }) => {
  const { isConnected, address } = useAccount()

  return (
    <Box {...props}>
      {isConnected ? (
        <Account symbols={symbols} address={address} />
      ) : (
        <ConnectWalletButton size={size} />
      )}
    </Box>
  )
}
